import { FacialAuthenticateContent } from '@facephi/inphinite-common';
import {
  IconName,
  IconSize,
  IconWeight,
  InphiniteThemeColors,
} from '@facephi/ui-react';

export type tInfo = LivenessIconInfo & {
  message: string;
  message_authentication?: string;
  size: IconSize;
  weight: IconWeight;
};

export type LivenessIconInfo = {
  iconName: IconName;
  iconColor: InphiniteThemeColors;
  backgroundColor: InphiniteThemeColors;
};

export type FilesOptionListInfo = {
  menuTitle: string;
  menuIcon?: IconName;
  menuIconLeft?: IconName;
  assetName: string;
  assetIcon?: IconName;
};

export type CustomDropdownAsset = {
  type: string;
  url: string;
  contentType: string;
  position: number;
};

export type FacialValidationState = (FacialAuthenticateContent & {
  id: string;
})[];

export const infoFacial: { [key in string]: tInfo } = {
  match: {
    message: 'The person on the document and the selfie match',
    message_authentication: 'The person of the selfie match',
    iconName: 'Check',
    iconColor: 'success400',
    backgroundColor: 'success100',
    weight: 'fill',
    size: '48',
  },
  notMatch: {
    message: 'The person on the document and the selfie dont match',
    message_authentication: 'The person dont match',
    iconName: 'X',
    iconColor: 'error400',
    backgroundColor: 'error100',
    weight: 'fill',
    size: '48',
  },
  notAble: {
    message:
      'We have not been able to verify. The photo may have some reflection or low resolution.',
    message_authentication:
      'We have not been able to verify. The photo may have some reflection or low resolution.',
    iconName: 'WarningCircle',
    iconColor: 'warning400',
    backgroundColor: 'warning100',
    weight: 'light',
    size: '48',
  },
};

export const infoLiveness: { [key in string]: LivenessIconInfo } = {
  success: {
    iconName: 'Check',
    iconColor: 'success400',
    backgroundColor: 'success100',
  },
  error: { iconName: 'X', iconColor: 'error400', backgroundColor: 'error100' },
};

export const filesOptionMenuInfo: { [key in string]: FilesOptionListInfo } = {
  video: {
    menuTitle: 'Videos',
    menuIcon: 'CaretDown',
    menuIconLeft: 'VideoCamera',
    assetName: 'Video recording',
    assetIcon: 'Play',
  },
  audio: {
    menuTitle: 'Audios',
    menuIcon: 'CaretDown',
    menuIconLeft: 'Microphone',
    assetName: 'Audio recording',
    assetIcon: 'Play',
  },
};
